import { forwardRef } from "react";
import { SIGN_GLYPH } from "../lib/astro";

// Off-screen premium card exported to PNG for sharing. Fixed 1080x1350 (portrait social).
const ShareCard = forwardRef(function ShareCard({ name, natal = {}, hd = {}, num = {}, psy, chinese = {} }, ref) {
  const big3 = [
    { label: "Sun", sign: natal.sun_sign },
    { label: "Moon", sign: natal.moon_sign },
    { label: "Rising", sign: natal.rising_sign },
  ];
  const stats = [
    { label: "Human Design", value: hd.type },
    { label: "Life Path", value: num.life_path },
    { label: "MBTI", value: psy?.mbti_type },
    { label: "Chinese", value: chinese.animal },
  ].filter((s) => s.value != null && s.value !== "");

  return (
    <div ref={ref} style={{
      position: "fixed", left: -99999, top: 0, width: 1080, height: 1350,
      background: "radial-gradient(120% 80% at 50% 0%, #17142B 0%, #0A0A0F 55%)",
      color: "#EDEBF2", fontFamily: "Outfit, sans-serif", padding: 80, boxSizing: "border-box",
      display: "flex", flexDirection: "column", justifyContent: "space-between",
    }}>
      <div>
        <div style={{ fontFamily: "'Space Mono', monospace", letterSpacing: 6, fontSize: 22, color: "#D9B45B", textTransform: "uppercase" }}>MyNsight</div>
        <div style={{ fontFamily: "Cormorant, serif", fontSize: 84, lineHeight: 1.02, marginTop: 28, fontWeight: 300 }}>
          {name ? `${name}'s` : "My"} cosmic<br />self-portrait
        </div>
      </div>

      <div style={{ display: "flex", gap: 28 }}>
        {big3.map((b) => (
          <div key={b.label} style={{ flex: 1, border: "1px solid rgba(217,180,91,0.25)", borderRadius: 24, padding: 32, background: "rgba(255,255,255,0.03)" }}>
            <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 18, letterSpacing: 4, color: "#9A97A8", textTransform: "uppercase" }}>{b.label}</div>
            <div style={{ fontFamily: "Cormorant, serif", fontSize: 64, color: "#D9B45B", marginTop: 8 }}>{SIGN_GLYPH[b.sign] || "·"}</div>
            <div style={{ fontFamily: "Cormorant, serif", fontSize: 40 }}>{b.sign || "—"}</div>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: 20 }}>
        {stats.map((s) => (
          <div key={s.label} style={{ minWidth: 220, flex: 1, borderTop: "2px solid rgba(124,111,224,0.5)", paddingTop: 18 }}>
            <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 18, letterSpacing: 3, color: "#9A97A8", textTransform: "uppercase" }}>{s.label}</div>
            <div style={{ fontFamily: "Cormorant, serif", fontSize: 46, color: "#EDEBF2", marginTop: 4 }}>{s.value}</div>
          </div>
        ))}
      </div>

      <div style={{ fontFamily: "'Space Mono', monospace", fontSize: 20, letterSpacing: 3, color: "#7C6FE0", textTransform: "uppercase" }}>
        mynsight.me · one portrait, every system
      </div>
    </div>
  );
});

export default ShareCard;
